export const initState = {
	suggestion: {
		_send: '',

		name: '',
		phone: '',
		message: '',

		code: '',
		showOtp: false,
	},
	complaint: {
		_send: '',

		name: '',
		phone: '',
		message: '',

		code: '',
		showOtp: false,
	},
};

export default initState;
